import { render, staticRenderFns } from "./milieux.vue?vue&type=template&id=f60638d2&"
import script from "./milieux.vue?vue&type=script&lang=js&"
export * from "./milieux.vue?vue&type=script&lang=js&"
import style0 from "./milieux.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports